import {
  G500,
  N400,
  N700,
  N900,
  primaryDark,
  R500,
  Y500,
} from '@/colors/colorsV1';
import { colors } from '@/colors';
import { animationAutoScroll } from './styles';

export const typographyVariant = {
  display: {
    lg: {
      fontWeight: 500,
      fontSize: 44,
      lineHeight: '48px',
      letterSpacing: 0,
    },
    md: {
      fontWeight: 500,
      fontSize: 36,
      lineHeight: '40px',
      letterSpacing: 0,
    },
  },
  heading: {
    lg: {
      fontWeight: 700,
      fontSize: 28,
      lineHeight: '30px',
      letterSpacing: 0,
    },
    md: {
      fontWeight: 700,
      fontSize: 24,
      lineHeight: '26px',
      letterSpacing: 0,
    },
    sm: {
      fontWeight: 700,
      fontSize: 20,
      lineHeight: '24px',
      letterSpacing: 0,
    },
  },
  subheading: {
    md: {
      fontWeight: 400,
      fontSize: 18,
      lineHeight: '24px',
      letterSpacing: 0,
    },
  },
  label: {
    default: {
      // old type for label
      textAlign: 'left',
      fontWeight: 400,
      fontSize: 12,
      lineHeight: 1.5,
      marginTop: 12,
      color: N400,
    },
    lg: {
      fontWeight: 400,
      fontSize: 18,
      lineHeight: '24px',
      letterSpacing: 0,
    },
    md: {
      fontWeight: 400,
      fontSize: 16,
      lineHeight: '20px',
      letterSpacing: 0,
    },
    sm: {
      fontWeight: 400,
      fontSize: 14,
      lineHeight: '16px',
      letterSpacing: 0,
    },
    xs: {
      fontWeight: 400,
      fontSize: 12,
      lineHeight: '16px',
      letterSpacing: 0,
    },
  },
  body: {
    default: {
      // old type for body
      textAlign: 'left',
      fontWeight: 400,
      fontSize: 14,
      lineHeight: 1.5,
      marginTop: 12,
      marginBottom: 0,
      color: N900,
    },
    lg: {
      fontWeight: 400,
      fontSize: 16,
      lineHeight: '24px',
      letterSpacing: 0.05,
    },
    md: {
      fontWeight: 400,
      fontSize: 14,
      lineHeight: '22px',
      letterSpacing: 0.05,
    },
    sm: {
      fontWeight: 400,
      fontSize: 12,
      lineHeight: '20px',
      letterSpacing: 0.05,
    },
    xs: {
      fontWeight: 400,
      fontSize: 10,
      lineHeight: '12px',
      letterSpacing: 0.05,
    },
  },
  stylized: {
    default: {
      fontWeight: 500,
      fontSize: 12,
      lineHeight: '16px',
      textTransform: 'uppercase',
    },
    tiny: {
      fontWeight: 500,
      fontSize: 10,
      lineHeight: '14px',
      textTransform: 'uppercase',
    },
  },
  link: {
    default: {
      textAlign: 'left',
      fontWeight: 700,
      fontSize: 14,
      lineHeight: 1,
      marginTop: 12,
      marginBottom: 0,
      color: colors.AJAIB_BLUE_5,
      letterSpacing: '0.05em',
      cursor: 'pointer',
      ':hover': {
        color: colors.AJAIB_BLUE_7,
      },
    },
    md: {
      textAlign: 'left',
      fontWeight: 700,
      fontSize: 14,
      lineHeight: '22px',
      letterSpacing: 0.05,
      color: colors.AJAIB_BLUE_5,
      cursor: 'pointer',
      ':hover': {
        color: colors.AJAIB_BLUE_7,
      },
    },
    sm: {
      textAlign: 'left',
      fontWeight: 700,
      fontSize: 12,
      lineHeight: '20px',
      letterSpacing: 0.05,
      color: colors.AJAIB_BLUE_5,
      cursor: 'pointer',
      ':hover': {
        color: colors.AJAIB_BLUE_7,
      },
    },
    xs: {
      textAlign: 'left',
      fontWeight: 700,
      fontSize: 10,
      lineHeight: '12px',
      letterSpacing: 0.05,
      color: colors.AJAIB_BLUE_5,
      cursor: 'pointer',
      ':hover': {
        color: colors.AJAIB_BLUE_7,
      },
    },
  },
  // old type variant
  title: {
    default: {
      textAlign: 'left',
      fontWeight: 700,
      fontSize: 24,
      lineHeight: 1.5,
      color: N900,
    },
  },
  subtitle: {
    default: {
      textAlign: 'left',
      fontWeight: 700,
      fontSize: 20,
      lineHeight: 1.5,
      color: N900,
    },
  },
  section: {
    default: {
      textAlign: 'left',
      fontWeight: 700,
      fontSize: 16,
      lineHeight: 1.5,
      marginTop: 8,
      marginBottom: 8,
      color: N900,
    },
  },
  subsection: {
    default: {
      textAlign: 'left',
      fontWeight: 700,
      fontSize: 14,
      lineHeight: 1.5,
      marginTop: 8,
      marginBottom: 8,
      color: N900,
    },
  },
  'popup-title': {
    default: {
      fontWeight: 700,
      fontSize: 16,
      lineHeight: 1.5,
      marginTop: 8,
      marginBottom: 8,
      color: N900,
      textAlign: 'center',
    },
  },
  'popup-body': {
    default: {
      fontWeight: 400,
      fontSize: 14,
      lineHeight: 1.5,
      marginTop: 8,
      marginBottom: 0,
      color: N700,
      textAlign: 'center',
    },
  },
  alert: {
    default: {
      textAlign: 'left',
      fontWeight: 400,
      fontSize: 12,
      lineHeight: 1.5,
    },
  },
  caption: {
    default: {
      textAlign: 'left',
      fontWeight: 400,
      fontSize: 12,
      lineHeight: 1.5,
      marginTop: 12,
      marginBottom: 0,
      color: N900,
    },
  },
};

export const sizeDefault = {
  display: 'md',
  heading: 'md',
  subheading: 'md',
  label: 'default',
  body: 'default',
  stylized: 'default',
  // old type variant
  title: 'default',
  subtitle: 'default',
  section: 'default',
  subsection: 'default',
  'popup-title': 'default',
  'popup-body': 'default',
  alert: 'default',
  caption: 'default',
  link: 'default',
};

export const tagDefault = {
  display: 'h1',
  heading: 'h1',
  label: 'div',
  body: 'p',
  stylized: 'span',
  // old type variant
  title: 'h1',
  subtitle: 'h2',
  section: 'h3',
  subsection: 'h4',
  'popup-title': 'h3',
  'popup-body': 'p',
  alert: 'span',
  caption: 'span',
  link: 'span',
};

export const alertTypeStyle = {
  default: {
    color: N900,
  },
  info: {
    color: primaryDark,
  },
  success: {
    color: G500,
  },
  caution: {
    color: Y500,
  },
  error: {
    color: R500,
  },
  link: {
    fontWeight: 700,
    color: colors.AJAIB_BLUE_5,
    cursor: 'pointer',
    marginTop: 12,
    ':hover': {
      color: colors.AJAIB_BLUE_7,
    },
  },
};

export const textOverflow = {
  nowrap: {
    whiteSpace: 'nowrap',
    overflow: 'visible',
  },
  clip: {
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'clip',
  },
  ellipsis: {
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
  },
  scroll: {
    whiteSpace: 'nowrap',
    overflow: 'scroll',
  },
  'auto-scroll': {
    whiteSpace: 'nowrap',
    overflow: 'visible',
    animation: `${animationAutoScroll} 5s linear infinite`,
  },
  'break-word': {
    whiteSpace: 'break-spaces',
    wordBreak: 'break-all',
  },
  newline: {
    whiteSpace: 'break-spaces',
  },
};
